
import { defineComponent, ref, reactive, computed } from "vue";

window.addEventListener('beforeunload', (e) => {
  e.preventDefault();
  e.returnValue = '';
});

export default defineComponent({});
